/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: d70118fc6fbc1ac5744ce80ec717c8ecc18bd5db6eb037d2cf569a68f431aead
 */
import {
  base_colorAction,
  base_colorActionHover,
  base_colorAlert,
  grey100,
  grey400,
  grey500,
  white100,
} from 'ext-ui/style/colors'
import {
  spacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: inline-block;
  line-height: 0;
  position: relative;

  .input {
    appearance: none;
    background: ${white100};
    border-color: ${grey500};
    border-radius: ${spacing(1)};
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    display: inline-block;
    flex-shrink: 0;
    height: ${spacing(5)};
    margin: 0;
    position: relative;
    transition: all 150ms ease;
    width: ${spacing(5)};
  }

  &.not-checked .input {

    &:hover {
      border-color: ${base_colorActionHover};
    }
  }

  &.checked .input {
    background: ${base_colorAction};
    border-color: ${base_colorAction};

    &:hover {
      background: ${base_colorActionHover};
      border-color: ${base_colorActionHover};
    }
  }

  &.disabled .input {
    background: ${grey100};
    border-color: ${grey400};
    cursor: not-allowed;
  }

  &.error .input {
    border-color: ${base_colorAlert};
  }

  &.checked.disabled .input {
    background: ${base_colorAction};
    border-color: ${base_colorAction};
    cursor: not-allowed;
    opacity: 0.4;
  }

  &.indeterminate .input {
    background: ${base_colorAction};
    border-color: ${base_colorAction};

    &:hover {
      background: ${base_colorActionHover};
      border-color: ${base_colorActionHover};
    }
  }

  .input:focus-visible {
    outline: 2px solid ${base_colorActionHover};
    outline-offset: 2px;
  }

  .indicator {
    inset: 0;
    pointer-events: none;
    position: absolute;
  }

  .indicator::before {
    background: ${white100};
    content: '';
    display: none;
    position: absolute;
  }

  &.checked:not(.indeterminate) .indicator::before {
    background: transparent;
    border-color: ${white100};
    border-style: solid;
    border-width: 0 2px 2px 0;
    display: block;
    height: 10px;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 5px;
  }

  &.indeterminate .indicator::before {
    background: ${white100};
    border: 0;
    display: block;
    height: 2px;
    left: 25%;
    top: 50%;
    transform: translateY(-50%);
    width: 50%;
  }
`
